import{p as o}from"./chunk-BX7EABCB.js";import{a as t,d as i}from"./chunk-XGSS6N64.js";import{m as a}from"./chunk-HBP5N4FR.js";a();i();o();var w=()=>{var e,r;return(e=t)!=null&&e.ReactNativeWebView?"reactNative":(r=t)!=null&&r.webkit?"ios":"web"};export{w as a};
//# sourceMappingURL=chunk-Q6SENGAO.js.map
